/**
 * Entrada «Despacho» (GEN-PX-007, spec §4): área central de ancho máximo 1240 px,
 * con márgenes y separación entre secciones de los tokens --dk-*. Pinta solo las
 * secciones que existen y tienen datos, en el orden fijo de `secciones.js`.
 */

import { SECCIONES } from './secciones.js'

const visible = (s, ctx) => Boolean(s.Componente) && (s.tieneDatos ? s.tieneDatos(ctx) : true)

export default function Entrada({ ctx, secciones = SECCIONES }) {
  const bloques = []
  for (const s of secciones) {
    if (s.columnas) {
      const cols = s.columnas.filter(c => visible(c, ctx))
      if (cols.length === 0) continue
      bloques.push(
        <div key={s.id} className={'dk-entrada__cols' + (cols.length > 1 ? ' dk-entrada__cols--2' : '')}>
          {cols.map(({ id, Componente }) => <Componente key={id} {...ctx} />)}
        </div>,
      )
    } else if (visible(s, ctx)) {
      const { Componente } = s
      bloques.push(<Componente key={s.id} {...ctx} />)
    }
  }
  return (
    <div className="dk-entrada">
      <div className="dk-entrada__area">{bloques}</div>
    </div>
  )
}
